<dl *ngIf="maps$ | async as maps">
	<ng-container *ngFor="let selection of maps">
		<dt>
			<cm-localize [name]="selection.key" />
		</dt>
		<dd>{{ selection.value }}</dd>
	</ng-container>
</dl>
